import React from 'react';
import Intl from '@fx-ui/intl';
import { FileThumb } from '@fx-ui/jdy-design-biz';

const UnSupportImagePreview: React.FunctionComponent = () => {
    return (
        <div className="fx-image-unsupported">
            <FileThumb className="fx-file-preview-icon" ext="png" />
            <div className="content">{Intl.get('image.not.support', { num: 20 })}</div>
        </div>
    );
};

export default UnSupportImagePreview;
